import { miniSidebarElementsFacility } from "./constant";

// Recursive filter for sidebar modules
function filterSidebarByModules(items, modules) {
  return items
    .map((item) => {
      let filteredSubData = item.subData
        ? filterSidebarByModules(item.subData, modules)
        : undefined;
      let filteredSubChildren = item.subChildren
        ? filterSidebarByModules(item.subChildren, modules)
        : undefined;
      let filteredSubSubChildren = item.subsubChildren
        ? filterSidebarByModules(item.subsubChildren, modules)
        : undefined;
      // If no moduleName, always include the item
      // console.log("subadmin1", item);
      if (!item.moduleName) {
        return {
          ...item,
          ...(filteredSubData ? { subData: filteredSubData } : {}),
          ...(filteredSubChildren ? { subChildren: filteredSubChildren } : {}),
          ...(filteredSubSubChildren
            ? { subsubChildren: filteredSubSubChildren }
            : {}),
        };
      }
      const isAllowedByModule =
        modules.includes(item.moduleName) ||
        modules.some((m) => m.startsWith(item.moduleName)) ||
        modules.some((m) => item.moduleName && m.includes(item.moduleName));
      const hasAllowedChildren =
        (filteredSubData && filteredSubData.length > 0) ||
        (filteredSubChildren && filteredSubChildren.length > 0) ||
        (filteredSubSubChildren && filteredSubSubChildren.length > 0);
      if (isAllowedByModule || hasAllowedChildren) {
        return {
          ...item,
          ...(filteredSubData ? { subData: filteredSubData } : {}),
          ...(filteredSubChildren ? { subChildren: filteredSubChildren } : {}),
          ...(filteredSubSubChildren
            ? { subsubChildren: filteredSubSubChildren }
            : {}),
        };
      }
      return null;
    })
    .filter(Boolean);
}

function getRoleBasedSidebar({
  user,
  sidebarElements1,
  sidebarElementsFacility,
}) {
  let sidebarElements = [];
  if (user?.companyAdmin && user?.isSubCompanyAdmin) {
    sidebarElements = filterSidebarByModules(sidebarElements1, user.modules);
  } else if (user?.companyAdmin) {
    sidebarElements = sidebarElements1;
  } else if (user?.facilityManger) {
    sidebarElements = sidebarElementsFacility;
  } else if (
    user?.modules &&
    Array.isArray(user.modules) &&
    user.modules.length > 0
  ) {
    sidebarElements = filterSidebarByModules(
      sidebarElementsFacility,
      user.modules
    );
  } else {
    sidebarElements = [];
  }
  return sidebarElements;
}

function filterMiniSidebarElements({ user, miniSidebarElements }) {
  if (user?.companyAdmin && user?.isSubCompanyAdmin) {
    return miniSidebarElements.filter((item) => {
      if (!item.moduleName) return true;
      return (
        user.modules?.includes(item.moduleName) ||
        user.modules?.some((m) => m.startsWith(item.moduleName)) ||
        user.modules?.some(
          (m) => item.moduleName && m.includes(item.moduleName)
        )
      );
    });
  } else if (user?.companyAdmin) {
    return miniSidebarElements;
  } else if (user?.facilityManger) {
    return miniSidebarElementsFacility;
  } else if (
    user?.modules &&
    Array.isArray(user.modules) &&
    user.modules.length > 0
  ) {
    return miniSidebarElementsFacility.filter((item) => {
      if (!item.moduleName) return true;
      return (
        user.modules?.includes(item.moduleName) ||
        user.modules?.some((m) => m.startsWith(item.moduleName)) ||
        user.modules?.some(
          (m) => item.moduleName && m.includes(item.moduleName)
        )
      );
    });
  } else {
    return [];
  }
}

export {
  filterSidebarByModules,
  getRoleBasedSidebar,
  filterMiniSidebarElements,
};
